module.exports = __webpack_public_path__ + "static/media/doctolib_logo.18878e56.png";